import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PLATFORM_URL } from '../constants/site';
import { brandColors } from '../theme';

const DesktopUserMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const { currentUser, userRole, loading, loginWithGoogle, logout } = useAuth();

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  if (loading) return null;

  if (!currentUser) {
    return (
      <Button
        color="inherit"
        onClick={loginWithGoogle}
        startIcon={<LoginIcon />}
        sx={{
          ml: 1,
          border: '1px solid rgba(255,255,255,0.25)',
          '&:hover': { borderColor: brandColors.gold, bgcolor: 'rgba(255,255,255,0.06)' },
        }}
      >
        Acceso clientes
      </Button>
    );
  }

  return (
    <>
      <Button
        color="inherit"
        onClick={handleMenuOpen}
        sx={{ ml: 1, textTransform: 'none' }}
      >
        {currentUser.displayName?.split(' ')[0] || 'Mi cuenta'}
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        {userRole === 'admin' && (
          <MenuItem
            onClick={() => {
              navigate('/admin');
              handleMenuClose();
            }}
          >
            <ListItemIcon><AdminPanelSettingsIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Administración</ListItemText>
          </MenuItem>
        )}
        {(userRole === 'client' || userRole === 'admin') && (
          <MenuItem
            onClick={() => {
              window.location.href = PLATFORM_URL;
              handleMenuClose();
            }}
          >
            <ListItemIcon><DashboardIcon fontSize="small" /></ListItemIcon>
            <ListItemText>Ir a la plataforma</ListItemText>
          </MenuItem>
        )}
        <MenuItem
          onClick={async () => {
            await logout();
            handleMenuClose();
          }}
        >
          <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Cerrar sesión</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default DesktopUserMenu;
